import React, { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AuthService from '../../services/authorization';
import { useSession } from '../../hooks/useSession';
import LoadingScreen from '../../components/LoadingScreen';
import { UserAccessLevels } from '../../enums';

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const authRef = useRef(new AuthService());
  const Auth = authRef.current;
  const { createSession } = useSession();

  useEffect(() => {
    const handleLogin = async () => {
      const accessToken = searchParams.get('accessToken');
      const customerNumber = searchParams.get('customerNumber');
      const email = searchParams.get('email');
      const redirectUrl = searchParams.get('redirectUrl');
      const isNewUser = searchParams.get('isNewUser');

      let finalRedirectUrl = `${window.location.protocol}//${window.location.host}`;
      if (redirectUrl) {
        finalRedirectUrl = redirectUrl;
      }

      if (accessToken) {
        try {
          Auth.clearSession();

          Auth.setAccessToken(accessToken);

          if (customerNumber) {
            Auth.setCurrentCustomerNumber(customerNumber);
          }

          const { currentUser, customer } = await createSession();

          if (!currentUser) {
            console.error('No current user found after session creation');
            navigate('/support');
            return;
          }

          if (redirectUrl) {
            window.location.href = finalRedirectUrl;
          } else {
            if (customer?.corporate_parent &&
              currentUser.access_level &&
              (currentUser.access_level === UserAccessLevels.Owner || currentUser.access_level === UserAccessLevels.Admin)) {
              navigate(`/corp/dashboard`);
            } else if (currentUser.access_level) {
              navigate(`/practice/dashboard`);
            } else {
              console.error('Invalid user access level:', currentUser.access_level);
              navigate('/support');
            }
          }
        } catch (error) {
          console.error('Error handling access token login:', error);
          navigate('/support');
        }
      } else {
        redirectToLogin(email, isNewUser, finalRedirectUrl);
      }
    };

    handleLogin();
  }, []);

  const redirectToLogin = (email: string | null, isNewUser: string | null, redirectUrl: string) => {
    let loginParams = `?service=ontraq&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    if (email) {
      loginParams += `&email=${email}`;
    }

    const loginPath = isNewUser ? '/register' : '';
    const destination = Auth.getLoginUrl(`${loginPath}${loginParams}`);

    window.location.href = destination;
  };

  return <LoadingScreen />;
};

export default Login;
